import lazyRequire from "../../../util/lazyRequire";
import { log } from "../../../util/log";
import { DialogManager } from "./DialogManager";
import { SharedDelegates } from "../../installer_fomod_shared/delegates/SharedDelegates";
export class VortexModInstaller {
    static async create(api, instanceId, gameId, unattended = false) {
        const delegates = new VortexModInstaller(api, instanceId, gameId, unattended);
        await delegates.initialize();
        return delegates;
    }
    fomod;
    mModInstaller;
    mApi;
    mInstanceId;
    mGameId;
    mScriptPath;
    mDialogManager;
    mSharedDelegates;
    // When true (collection install with preset choices), skip all dialog Redux
    // dispatches. The C# fomod still calls uiStartDialog/uiUpdateState/uiEndDialog
    // for each step, but in unattended mode we don't need to update the store —
    // choices come from the input preset, not from Redux state. Skipping these
    // eliminates dozens of expensive main-thread TSFN callbacks per fomod mod.
    mUnattended;
    constructor(api, instanceId, gameId, unattended = false) {
        this.fomod = lazyRequire(() => require("@nexusmods/fomod-installer-native"));
        this.mModInstaller = new this.fomod.NativeModInstaller(this.pluginsGetAllAsync, this.contextGetAppVersionAsync, this.contextGetCurrentGameVersionAsync, this.contextGetExtenderVersionAsync, this.uiStartDialog, this.uiEndDialog, this.uiUpdateState);
        this.mApi = api;
        this.mInstanceId = instanceId;
        this.mGameId = gameId;
        this.mUnattended = unattended;
    }
    async initialize() {
        this.mSharedDelegates = await SharedDelegates.create(this.mApi, this.mGameId);
    }
    dispose() {
        log("debug", "Disposing VortexModInstaller", {
            instanceId: this.mInstanceId,
        });
        this.mDialogManager?.dispose();
        this.mDialogManager = undefined;
    }
    /**
     * Calls FOMOD's install and converts the result to Vortex data
     */
    installAsync = async (files, stopPatterns, pluginPath, scriptPath, preset, preselect, validate) => {
        this.mScriptPath = scriptPath;
        return await this.mModInstaller.install(files, stopPatterns, pluginPath, scriptPath, preset, preselect, validate);
    };
    /**
     * Callback
     */
    pluginsGetAllAsync = (activeOnly) => {
        return this.mSharedDelegates.getAllPlugins(activeOnly);
    };
    /**
     * Callback
     */
    contextGetAppVersionAsync = () => {
        return this.mSharedDelegates.getAppVersion();
    };
    /**
     * Callback
     */
    contextGetCurrentGameVersionAsync = () => {
        return this.mSharedDelegates.getCurrentGameVersion();
    };
    /**
     * Callback
     */
    contextGetExtenderVersionAsync = (extender) => {
        return this.mSharedDelegates.getExtenderVersion(extender);
    };
    /**
     * Callback for starting FOMOD dialog
     * Delegates to DialogManager instance
     */
    uiStartDialog = (moduleName, image, selectCallback, contCallback, cancelCallback) => {
        if (this.mUnattended) {
            return;
        }
        log("debug", "Starting FOMOD dialog", { instanceId: this.mInstanceId });
        this.mDialogManager = new DialogManager(this.mApi, this.mInstanceId, this.mScriptPath);
        this.mDialogManager.enqueueDialog(moduleName, image, selectCallback, contCallback, cancelCallback);
    };
    /**
     * Callback for updating FOMOD dialog state
     * Delegates to DialogManager instance
     */
    uiUpdateState = (installSteps, currentStepId) => {
        if (this.mUnattended) {
            return;
        }
        if (!this.mDialogManager) {
            throw new Error("DialogManager not initialized");
        }
        // https://github.com/Nexus-Mods/NexusMods.App/blob/e6b99cff84443ce78081caefda7ffcd4ffc184a9/src/NexusMods.Games.FOMOD/CoreDelegates/UiDelegate.cs#L108-L109
        if (currentStepId < 0 || currentStepId >= installSteps.length) {
            return;
            //throw new Error('Invalid current step ID');
        }
        log("debug", "Updating FOMOD dialog state", {
            instanceId: this.mInstanceId,
            currentStepId,
            totalSteps: installSteps.length,
        });
        this.mDialogManager.updateDialogState(installSteps, currentStepId);
    };
    /**
     * Callback for ending FOMOD dialog
     * Delegates to DialogManager instance
     */
    uiEndDialog = () => {
        if (this.mUnattended) {
            return;
        }
        if (!this.mDialogManager) {
            log("debug", "Ending FOMOD dialog - already disposed", {
                instanceId: this.mInstanceId,
            });
            throw new Error("DialogManager not initialized");
        }
        log("debug", "Ending FOMOD dialog", { instanceId: this.mInstanceId });
        this.mDialogManager.endDialog();
    };
}
